// @ts-nocheck

import * as Types from '../../../../../../../../graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type UpdateCustomObjectMutationVariables = Types.Exact<{
  model: Types.CustomObjectUpdateModelInput;
}>;

export type UpdateCustomObjectMutation = { updateCustomObject: { uid: string } };

export const UpdateCustomObjectDocument = gql`
    mutation UpdateCustomObject($model: CustomObjectUpdateModelInput!) {
  updateCustomObject(model: $model) {
    uid
  }
}
    ` as unknown as DocumentNode<UpdateCustomObjectMutation, UpdateCustomObjectMutationVariables>;
